import { eq } from "discourse/truth-helpers";
import { i18n } from "discourse-i18n";

export default <template>
  {{#if (eq @user.name @user.username)}}
    {{@user.username}}
  {{else if @user.name}}
    {{i18n
      "community_media.username_with_nickname"
      username=@user.username
      nickname=@user.name
    }}
  {{else}}
    {{@user.username}}
  {{/if}}
</template>;
